import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import { apiClient } from '../lib/apiClient';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);

  const cargarSesion = useCallback(async () => {
    if (!apiClient.getToken()) {
      setUsuario(null);
      setLoading(false);
      return;
    }
    try {
      const data = await apiClient.get('/admin/auth/me');
      setUsuario(data.usuario);
    } catch {
      apiClient.setToken(null);
      setUsuario(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    cargarSesion();
  }, [cargarSesion]);

  const login = useCallback(async (email, password) => {
    const data = await apiClient.post('/admin/auth/login', { email, password });
    apiClient.setToken(data.token);
    setUsuario(data.usuario);
    return data.usuario;
  }, []);

  const logout = useCallback(() => {
    apiClient.setToken(null);
    setUsuario(null);
    window.location.href = '/admin/login';
  }, []);

  const permisos = useMemo(() => new Set(usuario?.permisos || []), [usuario]);

  const tienePermiso = useCallback((codigo) => permisos.has(codigo), [permisos]);

  const value = { usuario, loading, login, logout, permisos, tienePermiso, recargar: cargarSesion };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
  return ctx;
}
